import { render, staticRenderFns } from "./ModalCompanyGroup.vue?vue&type=template&id=29971c90"
import script from "./ModalCompanyGroup.vue?vue&type=script&lang=js"
export * from "./ModalCompanyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports